import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

function useBooks() {
  const [books, setBooks] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/books')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        let b = data?.data?.map((book) => {
          return {
            _id: book?._id,
            name: book?.name,
            serie: book?.serie?.name,
            grade: book?.grade?.name,
            createdAt: book?.createdAt,
          };
        });
        setBooks(b);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { books, setBooks, isLoading };
}

export default function Books() {
  const { books, setBooks, isLoading } = useBooks();
  const [name, setName] = React.useState('');
  const [serie, setSerie] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [coverImage, setCoverImage] = React.useState('');
  const [selectedBook, setSelectedBook] = React.useState(null);
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/books-update/${id}`);
  };

  const classes = useStyles();

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
    },
    {
      name: 'serie',
      label: 'Serie',
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'createdAt',
      label: 'Fecha De Creación',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(books[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los libros seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/books/${
            books[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
        if (data.success) {
          setBooks(books.splice(row.dataIndex, 1));

          setName('');
          setSerie('');
          setGrade('');
          setCoverImage('');
        }
      });
    }
  };

  useEffect(() => {
    if (selectedBook) {
      setName(selectedBook?.name);
      setSerie(selectedBook?.serie);
      setGrade(selectedBook?.grade);
      setCoverImage(selectedBook?.coverImage);
    }
  }, [selectedBook]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        libros creados a la fecha y autorizadas por la gerencia de Ediciones
        Mileno, ten mucha precaución de eliminar alguna de ellas, si ya cuenta
        contenido asociado, este proceso no se puede recuperar.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de libros'}
          data={books}
          columns={columns}
          options={{
            filter: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
